var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container warpp",
      staticStyle: { height: "calc(100vh - 170px)", "overflow-y": "auto" },
    },
    [
      _c(
        "el-collapse",
        {
          on: { change: _vm.handleChange },
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        [
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: _vm.$t("customerManagements.otherInformation"),
                name: "1",
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "formDataOther",
                  attrs: { model: _vm.formData, "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.orderNumberType"
                                ),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t(
                                      "customerManagements.pleaseInput"
                                    ),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                                prop: "orderNumberType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "customerManagements.default"
                                    ),
                                  },
                                  model: {
                                    value: _vm.formData.orderNumberType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "orderNumberType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.orderNumberType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 1,
                                    attrs: { value: 1, label: "AJ" },
                                  }),
                                  _c("el-option", {
                                    key: 2,
                                    attrs: { value: 2, label: "ANJBR" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerManagements.enableDistributionOrder"
                                ),
                                prop: "deliveryNoteFlag",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "customerManagements.default"
                                    ),
                                  },
                                  model: {
                                    value: _vm.formData.deliveryNoteFlag,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "deliveryNoteFlag",
                                        $$v
                                      )
                                    },
                                    expression: "formData.deliveryNoteFlag",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 0,
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.disable"),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: 1,
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.enable"),
                                      value: 1,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("trajectory.enableTrackingAlert"),
                                prop: "isTrackStopAlert",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "customerManagements.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.formData.isTrackStopAlert,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "isTrackStopAlert",
                                        $$v
                                      )
                                    },
                                    expression: "formData.isTrackStopAlert",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 0,
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.disable"),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: 1,
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.enable"),
                                      value: 1,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "trajectory.trackingDurationThreshold"
                                ),
                                prop: "trackStopAlertDays",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "customerManagements.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.formData.trackStopAlertDays,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "trackStopAlertDays",
                                        $$v
                                      )
                                    },
                                    expression: "formData.trackStopAlertDays",
                                  },
                                },
                                _vm._l(19, function (item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: {
                                      label:
                                        item +
                                        1 +
                                        _vm.$t("WorkCentreTable.Day"),
                                      value: item + 1,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("customerManagements.returnMode"),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t(
                                      "customerManagements.pleaseChoose"
                                    ),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                                prop: "reverseType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "customerManagements.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.formData.reverseType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "reverseType", $$v)
                                    },
                                    expression: "formData.reverseType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.returnToPlatformWarehouse"
                                      ),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t(
                                        "trajectory.newOrderReturn"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "3",
                                    attrs: {
                                      label: _vm.$t(
                                        "trajectory.originalOrderReturnD2D"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.customer.type === "edit" || _vm.customer.type === "add"
        ? _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "right", "margin-top": "15px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.clearData()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("customerManagements.confirm")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }